import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { BehaviorSubject, filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { WindowEnums } from 'src/app/enum/window-enums';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { OptionWindowModel } from 'src/app/models/authentication/option-window.model';
import { UserModel } from 'src/app/models/authentication/user.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { CostCenterPriceTableModel } from 'src/app/models/tables/archive/cost-center-price-table';
import { CostCenterPriceService } from 'src/app/services/archive/cost-center-price.service';
import { OptionWindowService } from 'src/app/services/authentication/option-window.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import { ImportCostCenterPriceComponent } from '../import-cost-center-price/import-cost-center-price.component';
import { ProfileUserEnums } from 'src/app/enum/profile-user-enums';
import { OptionWindow } from 'src/app/enum/option-window-enums';
import { CostCenterPriceModel } from 'src/app/models/archive/cost-center-price.model';
import { RegisterCostCenterPriceComponent } from '../register-cost-center-price/register-cost-center-price.component';
import { BranchService } from 'src/app/services/management/branch.service';
import { CostCenterService } from 'src/app/services/archive/cost-center.service';
import { CostCenterModel } from 'src/app/models/archive/cost-center.model';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';

@Component({
  selector: 'app-cost-center-price',
  templateUrl: './cost-center-price.component.html',
  styleUrls: ['./cost-center-price.component.scss'],
  standalone: false
})
export class CostCenterPriceComponent implements OnInit {

  @ViewChild('costCenterPriceImportModal') costCenterPriceImportModalComponent?: CustomModalComponent | null = null;
  @ViewChild('costCenterPriceRegisterModal') costCenterPriceRegisterComponent?: CustomModalComponent | null = null;

  ascendant: boolean = true;
  blockForm: boolean = false;
  branchId: number = 0;
  columnSort: string | null = null;
  componentCostCenterPriceImportModal = ImportCostCenterPriceComponent;
  componentRegisterModal = RegisterCostCenterPriceComponent;
  costCenterCode: number | null = null;
  costCenterData: PagedResponseModel<CostCenterPriceTableModel> = new PagedResponseModel<CostCenterPriceTableModel>();
  costCenterHeader: ColumnResponseModel[] = [];
  costCenterPriceRegister: CostCenterPriceModel = new CostCenterPriceModel();
  filters: ColumnResponseModel[] = [];
  inputsForRegisterModals$ = new BehaviorSubject<any>({
    blockForm: false,
    costCenterPriceModel: new CostCenterPriceModel(),
    openModal: false,
    openFrom: ''
  });
  isOpened: string | undefined = undefined;
  limit: number = 10;
  listObservers: Subscription[] = [];
  nameWindow: string = 'Precios por C.Costos';
  openFromRegister: string = "";
  output$ = new Subject<any>();
  page: number = 1;
  permissionUpdatable: boolean = false;
  permissionsUser: Array<OptionWindowModel> = new Array<OptionWindowModel>();
  projectName = ProjectName.projectName;
  subscription: Subscription;
  tableActions: TableAction[] = [
    {
      label: 'Editar',
      icon: 'pi pi-pencil',
      action: 'edit'
    }, {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      action: 'delete'
    },
  ];
  url: string = 'cost-center-price';
  userAuthenticated: UserModel = new UserModel();

  constructor(private branchService: BranchService,
    private confirmDialogService: ConfirmDialogService,
    private costCenterPriceService: CostCenterPriceService,
    private costCenterService: CostCenterService,
    private headerService: HeaderService,
    private optionWindowService: OptionWindowService,
    private router: Router,
    private title: Title,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService) { }

  async ngOnInit() {
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    this.headerService.setTitle(this.nameWindow);
    const filters = localStorage.getItem(this.url);
    if (filters) this.filters = JSON.parse(filters);
    this.getPermission();
    await Promise.all([
      this.getColumnsForGeneralConsultation(),
      this.getAllCostCenterPricesWithPagination(),
    ]);
    if (this.filters) {
      const costCenterFilter = this.filters.find(f => f.propertyName === 'costCenterCode') || null;
      await this.prepareCostCenterData(costCenterFilter);
    }
    this.subscription = this.output$.subscribe(({ payload }) => {
      this.reloadList(payload);
    });
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  ngOnDestroy() {
    this.listObservers.forEach(sub => sub.unsubscribe());
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async createCostCenterPrice() {
    this.openFromRegister = "createCostCenterPrice";
    if (this.branchId && this.costCenterCode) {
      const costCenter = await this.getCostCenter(this.branchId, this.costCenterCode);
      if (costCenter) {
        this.costCenterPriceRegister.costCenterId = costCenter.costCenterId;
        this.costCenterPriceRegister.costCenter = costCenter;
      }
    } else {
      this.costCenterPriceRegister = new CostCenterPriceModel();
    }
    this.openRegisterModal();
  }

  async deleteCostCenterPrice(costCenterPrice: CostCenterPriceTableModel) {
    if (!this.permissionUpdatable) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para eliminar el precio por centro de costos. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    if (await this.confirmDialogService.confirm('¿Realmente desea eliminar el centro de costos?')) {
      try {
        await firstValueFrom(this.costCenterPriceService.deleteCostCenterPrice(costCenterPrice.costCenterPriceId));
        await this.getAllCostCenterPricesWithPagination();
        this.toastHandlerService.showToast(
          'success',
          'El precio por centro de costos fue eliminado exitosamente.'
        );
      } catch (error) {
        console.error('Error al eliminar el precio por centro de costos.', error);
      }
    }
  }

  async editCostCenterPrice(id: number) {
    try {
      const costCenterPrice = await firstValueFrom(this.costCenterPriceService.getCostCenterPriceById(id));
      this.costCenterPriceRegister = costCenterPrice;
      this.openFromRegister = "editCostCenterPrice";
      this.openRegisterModal();
    } catch (error) {
      console.error('error al obtner el precio por centro de costos por id.', error);
    }
  }

  async exportGeneralConsultation() {
    try {
      const response = await firstValueFrom(
        this.costCenterPriceService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant)
      );
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Precios C.Costos.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar los precios por centros de costos:', error);
    }
  }

  async getCostCenter(branchId: number, costCenterCode: number): Promise<CostCenterModel | null> {
    try {
      return await firstValueFrom(this.costCenterService.getCostCenterByCode(branchId, costCenterCode));
    } catch (error) {
      console.error(`Error al obtener el centro de costos por código.`, error);
      return null;
    }
  }

  async getFirstBranchByUserAuthenticatedAsync() {
    try {
      const branch = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = branch.branchId;
    } catch (error) {
      console.error('Error al obtener la sucursal del usuario.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast(
          'error',
          `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`
        );
      }
    } else {
      localStorage.clear();
    }
    this.getUserAuthenticated();
    await Promise.all([
      this.getPermissionProfileByUrl(),
      this.getPermissionsForUserByWindow()
    ]);
  }

  async getPermissionProfileByUrl() {
    try {
      this.permissionUpdatable = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getUserAuthenticated() {
    const load = this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0))
      .subscribe(user => {
        this.userAuthenticated = user;
      });
    this.listObservers.push(load);
  }

  async getPermissionsForUserByWindow() {
    try {
      this.permissionsUser = await firstValueFrom(
        this.optionWindowService.getPermissionsForUserByWindow(WindowEnums.CostCenterPrice)
      );
    } catch (error) {
      console.error('Error al obtener los permisos del usuario para la ventana de precios por centros de costos.', error);
    }
  }

  async getColumnsForGeneralConsultation() {
    try {
      if (this.costCenterHeader.length === 0) {
        this.costCenterHeader = await firstValueFrom(this.costCenterPriceService.getColumnsForGeneralConsultation());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta de precios por centros de costos.', error);
    }
  }

  async getAllCostCenterPricesWithPagination() {
    try {
      this.costCenterData = await firstValueFrom(
        this.costCenterPriceService.getAllCostCenterPricesWithPagination(
          this.page, this.limit, this.columnSort, this.ascendant, this.filters
        )
      );
    } catch (error) {
      console.error('Error al buscar los datos de precios por centros de costos.', error);
    }
  }

  newRegister() {
    this.router.navigate([`${this.url}/register`]);
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters
      .map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index)
      .map((item: any) => item.value);

    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number; sortField?: string; sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField ?? null;
    this.ascendant = event.sortOrder === 1;
    await this.getAllCostCenterPricesWithPagination();
  }

  openRegisterModal() {
    this.inputsForRegisterModals$.next({
      blockForm: this.blockForm,
      costCenterPriceModel: this.costCenterPriceRegister,
      openFrom: this.openFromRegister
    });
    this.costCenterPriceRegisterComponent?.show();
    this.costCenterPriceRegister = new CostCenterPriceModel();
  }

  async onAction(event: { action: string, item?: CostCenterPriceTableModel, selectedItems?: number[] }) {
    if (event.action === 'edit' && event.item) {
      await this.editCostCenterPrice(event.item!.id);
    }
    if (event.action === 'delete' && event.item) {
      await this.deleteCostCenterPrice(event.item);
    }
  }

  async onImport() {
    if (this.userAuthenticated.profileUser.code == ProfileUserEnums.administrador || this.permissionsUser.find(x => x.code == OptionWindow.Importar)) {
      if (this.permissionUpdatable) {
        this.costCenterPriceImportModalComponent && this.costCenterPriceImportModalComponent.show();
      } else {
        this.toastHandlerService.showToast(
          'warning',
          `El usuario no tiene permisos para la edición de centro de costos. Comuníquese con el administrador del sistema.`
        );
      }
    } else {
      this.toastHandlerService.showToast(
        'warning',
        `El usuario no tiene permisos para importar centro de costos, comuniquese con el administrador del sistema.`
      );
    }
  }

  async onExport() {
    await this.exportGeneralConsultation();
  }

  async onTableFilterChange(event: { filters: ColumnResponseModel[] }) {
    this.filters = event.filters || [];
    const costCenterFilter = this.filters.find(f => f.propertyName === 'costCenterCode');
    await this.prepareCostCenterData(costCenterFilter ?? null);
  }

  async prepareCostCenterData(costCenterFilter: ColumnResponseModel | null) {
    try {
      await this.getFirstBranchByUserAuthenticatedAsync();
      this.costCenterCode = costCenterFilter?.valueFilter ?? null;
      if (!this.costCenterCode) {
        this.costCenterPriceRegister = new CostCenterPriceModel();
      }
    } catch (error) {
      console.error('Error preparando los datos de sucursal.', error);
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  async reloadList(reload: boolean) {
    if (reload) {
      await this.getAllCostCenterPricesWithPagination();
    }
  }
}
